import React from "react";
import { useUserContext } from "../../context/UserProvider";



export default function DisplayName({ uid, fullName = "", className = "" }) {
  if (!uid) throw new Error("No uid")
  const { FOUNDER_UIDS } = useUserContext()
  const isFounder = FOUNDER_UIDS.includes(uid)
  return <div className="flex items-center gap-1">
    <p className={"font-medium mb-0 text-md " + className}>{fullName}</p>
    {isFounder &&
      <img className="h-4" src="/img/Member_badge.png" alt="Founder badge" />
    }
  </div>
}